import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Uusi tuote',
  fields: {
    type: {
      label: 'Tuotetyyppi',
      options: {
        [SubscriptionProductType.Plan]: 'Paketti',
        [SubscriptionProductType.AddOn]: 'Lisäosa',
        [SubscriptionProductType.GoogleAdsPlan]: 'Google Ads -paketti',
      },
    },
    name: {
      label: 'Sisäinen nimi',
      placeholder: 'Kirjoita tuotteen sisäinen nimi',
    },
    public_name: {
      label: 'Julkinen nimi',
      placeholder: 'Kirjoita tuotteen julkinen nimi',
    },
    description: {
      label: 'Kuvaus',
    },
  },
  buttons: {
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  feedback: {
    missing_info: 'Puuttuvia tietoja',
  },
  toasts: {
    plan_got_created: 'Tuote luotu',
    plan_got_updated: 'Tuote päivitetty',
  },
};
